module.exports = __webpack_public_path__ + "static/media/artist.84de416f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/store/designer/artist.jpg
// module id = 207
// module chunks = 0